import React from "react";
import PropTypes from "prop-types";
import "./DateTimeNowButton.css";
import { Box } from "@mui/material";
import UpdateIcon from "@mui/icons-material/Update";
import StyledTooltip from "../../StyledTooltip/StyledTooltip";

export default function DateTimeNowButton({ onClick, height }) {
  return (
    <StyledTooltip title="Enter Current Time">
      <Box
        className="DateTimeNowButton"
        sx={{ backgroundColor: "primary.60", height: height }}
        onClick={onClick}
      >
        <UpdateIcon sx={{ color: "white_opacity.100" }} />
      </Box>
    </StyledTooltip>
  );
}

DateTimeNowButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  height: PropTypes.string
};